<script lang="ts">
    import {AutocompleteController} from './utils';
    import AutocompleteResultList from './AutocompleteResultList.svelte';
    import type {ComponentSize} from '../types';

    export let search: (_: string) => any[] | Promise<any[]>;
    export let currentInputValue = '';
    export let debounce = 0;
    export let getResultValue: (_: any) => string = (result) => result.toString();
    export let size: ComponentSize = 'md';

    const autocompleteController = new AutocompleteController(search, currentInputValue, debounce, getResultValue);

    $: autocompleteController.updateCurrentInputValue(currentInputValue);
</script>

<template>
    <div class="dropdown">
        <slot {autocompleteController}></slot>
        <AutocompleteResultList {autocompleteController} {size}/>
    </div>
</template>